var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.2901 4.22031C17.3301 1.27031 12.5301 1.27031 9.59015 4.22031C7.52015 6.27031 6.90015 9.22031 7.70015 11.8203L3.00015 16.5203C2.67015 16.8603 2.44015 17.5303 2.51015 18.0103L2.81015 20.1903C2.92015 20.9103 3.59015 21.5903 4.31015 21.6903L6.49015 21.9903C6.97015 22.0603 7.64015 21.8403 7.98015 21.4903L8.80015 20.6703C9.00015 20.4803 9.00015 20.1603 8.80015 19.9603L6.86015 18.0203C6.57015 17.7303 6.57015 17.2503 6.86015 16.9603C7.15015 16.6703 7.63015 16.6703 7.92015 16.9603L9.87015 18.9103C10.0601 19.1003 10.3801 19.1003 10.5701 18.9103L12.6901 16.8003C15.2801 17.6103 18.2301 16.9803 20.2901 14.9303C23.2401 11.9803 23.2401 7.17031 20.2901 4.22031ZM15.0001 12.0003C13.6201 12.0003 12.5001 10.8803 12.5001 9.50031C12.5001 8.12031 13.6201 7.00031 15.0001 7.00031C16.3801 7.00031 17.5001 8.12031 17.5001 9.50031C17.5001 10.8803 16.3801 12.0003 15.0001 12.0003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C16.3807 12 17.5 10.8807 17.5 9.5C17.5 8.11929 16.3807 7 15 7C13.6193 7 12.5 8.11929 12.5 9.5C12.5 10.8807 13.6193 12 15 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.cd731d1b2026afed2977b347991f54a0.svg";
export { ForwardRef as ReactComponent };